import { render, staticRenderFns } from "./Candidature.vue?vue&type=template&id=71812993&"
import script from "./Candidature.vue?vue&type=script&lang=js&"
export * from "./Candidature.vue?vue&type=script&lang=js&"
import style0 from "./Candidature.vue?vue&type=style&index=0&id=71812993&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports